import ConversationTemplate from './components/conversation'
import {EVENTS} from '../../events';
import {delay} from '../../utils';

export class ConversationBuilder  {
	// @var ConversationItem[]
	items = [];
    doing_ajax = false;
    loaded_all_items = false;

	constructor(chat) {
		this.chat = chat;
		this.el = this.chat.$el.find('.conversation-list')
        this.subscribe();
	}

    subscribe() {
        this.el.on('scroll', () => this.on_scoll());
        this.chat.on(EVENTS.WSCHAT_ON_NO_CONVERSATIONS, () => this.on_no_conversations())
        this.chat.on(EVENTS.WSCHAT_ON_FETCH_CONVERSATIONS, (conversations) => this.on_fetch_conversations(conversations));
		this.chat.on(EVENTS.WSCHAT_ON_DELETE_CONVERSATIONS, id => this.on_delete(id));

        this.chat.$el.find('.search-box input[name=conversation_status]').on('change', () => {
			this.reset();
			this.chat.connector.start_conversation_chain();
        	this.chat.connector.start_conversation(this.build_params());
        });

        this.chat.$el.find('.search-box input[name=search-control]').on('keyup', delay(() => {
			this.reset();
			const params = this.build_params();

			if (params.search.trim() === '') {
				this.chat.connector.start_conversation_chain();
				this.chat.connector.start_conversation();
			} else {
				this.chat.connector.stop_conversation_chain();
				this.chat.connector.get_conversations(params);
			}
		}, 500));
    }

    on_scoll() {
        const diff = this.el[0].scrollHeight - (this.el.height() + this.el.scrollTop());

        if (diff <= SCROLL_BUFFER && this.doing_ajax === false && this.loaded_all_items === false) {
            this.doing_ajax = true;
            this.chat.connector.get_conversations(this.build_params());
        }
    }

    on_no_conversations() {
       if (this.items.length) {
           this.loaded_all_items = true;
           return;
       }

        const no_conversation_alert = this.chat.$el.find('.no-conversation-alert').clone();
        this.el.html(no_conversation_alert.removeClass('d-none'));
    }

    on_fetch_conversations(conversations) {
        conversations.forEach(conversation => this.add(conversation));
        this.render();

		this.set_conversation_if_not();
    }

    on_delete(id) {
		// this.chat.connector.stop_conversation_chain();
		const item = this.items.find(item => item.conversation.id === id);
		item.delete();
		this.items = this.items.filter(item => item.conversation.id != id);

		if (this.chat.conversation.id === id) {
			this.chat.conversation = undefined;
		}

		this.render();

		this.set_conversation_if_not();
    }

    set_conversation_if_not() {
    	if (this.chat.connector.is_conversation_chain_stopped() || this.chat.conversation) {
    		return;
    	}
        setTimeout(() => {
            const activeItem = this.el.find('.active[data-conversation-id]').length
            if (activeItem === 0) {
            	const query_conversation_id = this.get_conversion_id_from_url();
            	if (query_conversation_id) {
            		const div = this.el.find(`[data-conversation-id=${query_conversation_id}]`);
            		if (div.length) {
            			div.click();
            		} else {
            			console.log('conversation not found');
            		}
            	} else {
            		this.el.find('[data-conversation-id]').eq(0).click();
            	}
            }
        }, 1000);
    }

    get_conversion_id_from_url() {
    	const params = new URLSearchParams(location.search);

		return params.get('conversation_id');
    }

    build_params() {
        const params = {};

        const length = this.items.length;

        if (length) {
            params.before = this.items[length - 1].conversation.updated_at;
        }

        params.search = this.chat.$el.find('.search-box input[name=search-control]').val();
        params.status = this.chat.$el.find('input[name=conversation_status]:checked').val();

        return params;
    }

	add(conversation) {
		const exists = this.find(conversation);

		conversation.is_selected = this.chat.conversation && conversation.id === this.chat.conversation.id;

		if (exists) {
			exists.replace(conversation);
		} else {
			this.items.push(new ConversationItem(conversation));
		}
	}

	find(conversation) {
		return this.items.find(item => item.conversation.id === conversation.id);
	}

	sort() {
		this.items.sort((a,b) => {
			if (a.conversation.recent_message && b.conversation.recent_message) {
				return b.conversation.recent_message.id - a.conversation.recent_message.id;
			}
			return new Date(a.conversation.last_update) > new Date(b.conversation.last_update) ? -1 : 1;
		});
	}

	render() {
		this.sort();

		for (let item of this.items) {
            this.el.append(item.domEl);
		}

        this.doing_ajax = false;
	}

	reset() {
		this.items = [];
		this.el.html('');
	}
}

export class ConversationItem {
	constructor(conversation) {
		this.conversation = conversation;

		this.domEl = ConversationTemplate(conversation);

		this.update();
	}

	update() {
		if (this.conversation.is_user_online) {
			this.domEl.hasClass('online') === false && this.domEl.addClass('online');
		} else {
			this.domEl.hasClass('online') && this.domEl.removeClass('online');
		}

		if (this.conversation.is_selected) {
			this.domEl.hasClass('active') === false && this.domEl.addClass('active');
		} else {
			this.domEl.hasClass('active') && this.domEl.removeClass('active');
		}

        if (this.conversation.user && this.conversation.user.meta.avatar) {
			this.domEl.find('img.profile-image').attr('src', this.conversation.user.meta.avatar)
        }
	}

	replace(conversation) {
		this.conversation = conversation;
		const newEl = ConversationTemplate(conversation);
		this.domEl.html(newEl.html());

		this.update();
	}

	delete() {
		this.domEl.remove();
	}
}

const SCROLL_BUFFER = 100;
